import { useNavigate } from 'react-router-dom';
import BottomNav from '@/components/BottomNav';

const quoteRequests = [
  {
    id: 'q1',
    title: '예복 견적 요청',
    status: 'received',
    date: '2026.04.28',
    count: 2,
    offers: [
      {
        vendorName: '오드리드레스',
        price: '280만원',
        items: '반수제 예복 + 촬영 대여복',
        message: '지혜님의 조건에 맞춰 반수제 예복과 촬영용 대여복 패키지로 제안드립니다.',
        matchRate: 94,
        isNew: true,
      },
      {
        vendorName: '쏘로우샵',
        price: '195만원',
        items: '촬영+본식 대여 패키지',
        message: '합리적인 예산으로 촬영과 본식을 모두 커버하는 패키지입니다.',
        matchRate: 91,
        isNew: false,
      },
    ],
  },
  {
    id: 'q2',
    title: '예물 견적 요청',
    status: 'pending',
    date: '2026.04.30',
    count: 0,
    offers: [],
  },
];

export default function Quotes() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] bg-cream flex flex-col">
      <div className="px-5 pt-6 pb-4 bg-white border-b border-cream-dark">
        <h1 className="text-navy text-xl font-bold">견적함</h1>
        <p className="text-beige-dark text-sm mt-1">요청하신 견적과 받은 제안을 확인하세요</p>
      </div>

      <div className="flex-1 overflow-y-auto px-5 py-4">
        <div className="space-y-4">
          {quoteRequests.map((req) => (
            <div key={req.id} className="bg-white rounded-2xl border border-cream-dark overflow-hidden">
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <p className="font-semibold text-navy text-sm">{req.title}</p>
                    <p className="text-beige-dark text-xs mt-0.5">{req.date} 요청</p>
                  </div>
                  <span
                    className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                      req.status === 'received'
                        ? 'bg-navy/10 text-navy'
                        : 'bg-cream text-beige-dark border border-cream-dark'
                    }`}
                  >
                    {req.status === 'received' ? '제안 받음' : '진행 중'}
                  </span>
                </div>
                <div className="flex items-center gap-1 mt-1">
                  <i className="ri-mail-line text-beige-dark text-xs" />
                  <span className="text-beige-dark text-xs">{req.count}개의 제안</span>
                </div>
              </div>

              {req.offers.length > 0 && (
                <div className="border-t border-cream-dark">
                  {req.offers.map((offer, i) => (
                    <button
                      key={i}
                      onClick={() => navigate('/vendors')}
                      className={`w-full p-4 text-left cursor-pointer hover:bg-cream transition-colors ${
                        i < req.offers.length - 1 ? 'border-b border-cream-dark' : ''
                      }`}
                    >
                      <div className="flex items-start justify-between gap-2">
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <p className="font-semibold text-navy text-sm">{offer.vendorName}</p>
                            {offer.isNew && (
                              <span className="px-1.5 py-0.5 rounded bg-softgold/15 text-softgold text-[10px] font-medium">
                                새 제안
                              </span>
                            )}
                          </div>
                          <p className="text-navy font-bold text-base">{offer.price}</p>
                          <p className="text-beige-dark text-xs mt-0.5">{offer.items}</p>
                          <p className="text-gray-500 text-xs mt-1 leading-relaxed">{offer.message}</p>
                        </div>
                        <div className="shrink-0 text-center">
                          <p className="text-navy font-bold text-sm">{offer.matchRate}%</p>
                          <p className="text-beige-dark text-[10px]">매칭률</p>
                        </div>
                      </div>
                      <div className="flex gap-2 mt-3">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate('/vendors');
                          }}
                          className="flex-1 bg-navy text-white rounded-lg py-2 text-xs font-medium cursor-pointer hover:bg-navy-light transition-colors whitespace-nowrap"
                        >
                          자세히 보기
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          className="px-3 py-2 bg-cream text-navy rounded-lg text-xs font-medium border border-cream-dark cursor-pointer hover:bg-cream-dark transition-colors whitespace-nowrap"
                        >
                          비교 담기
                        </button>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}